/* eslint-disable import/no-anonymous-default-export */
import { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import RenombradorLayout from "../../common/components/RenombradorLayout";
import useLotesRenombradoAPI from "../hooks/useLotesRenombradoAPI";
import InfraccionesBrowser from "../../infracciones/components/InfraccionesBrowser";
import RenombradoViewer from "../components/RenombradoViewer";
import useCodigosInfraccionAPI from "../../codigos-infraccion/hooks/useCodigosInfraccionAPI";
import useEstadisticasAPI from "../../estadisticas/useEstadisticasAPI";


export default () => {
    const api = useLotesRenombradoAPI();
    const estadisticasApi = useEstadisticasAPI();
    const codigosInfraccionApi = useCodigosInfraccionAPI();

    const listCodigosInfraccion = async (etiqueta: string) => {
        //TODO: Cachear
        return await codigosInfraccionApi.list({ $filter: [`Etiqueta eq '${etiqueta}'`], $expand: ['EtiquetasImagenes'] });
    }

    return (
        <RenombradorLayout>
            <div style={{ marginTop: "1rem" }}>
                <InfraccionesBrowser
                    getItemStatusColor={(currentIndex, currentPage, infraccion) => {
                        if (infraccion.Estado == 'RENOMBRADA' && infraccion.Patente) {
                            return '#43a047';

                        }
                        else if (infraccion.Estado == 'RENOMBRADA') {
                            return '#e53935';
                        }
                        else {
                            return 'white';
                        }
                    }}
                    limit={100}
                    title="Renombrado de infracciones"
                    list={(top, skip, filter) => api.getAssignedInfractions({ $top: top, $skip: skip, $filter: filter })}
                    findById={(id) => api.getAssignedInfractions({ $filter: [`Id eq ${id}`] })}
                    groupBy={(query, type) => api.getAssignedInfractionsGroup(query, type)}
                    getMonthStatistics={(month: number) => estadisticasApi
                        .getEstadisticasInfracciones({
                            $filter: [
                                `year(FechaRenombrado) eq ${(new Date()).getFullYear()}`,
                                `month(FechaRenombrado) eq ${month}`,
                                "Estado ne 'PENDIENTE'"]
                        }, 'MES', 'FechaRenombrado')
                    }
                    yesterdayStatisticsText="Renombradas ayer"
                    todayStatisticsText="Renombradas hoy"
                    statisticsProcess="RENOMBRADO"
                    breadcrumbUrl="/lotes-renombrado/renombrar"
                    getProgress={(data) => parseFloat(((data.cantidadInfraccionesRenombradas / data.cantidadInfracciones) * 100).toFixed(0))}
                    getProgressQuantity={(data) => `${data.cantidadInfraccionesRenombradas} de ${data.cantidadInfracciones}`}
                >
                    <RenombradoViewer
                        listCodigosInfraccion={listCodigosInfraccion}
                        onBeforeSave={(data, context) => context.goForward()}
                        renombrar={api.renombrar}
                    />
                    {/*infraccionesResponse &&
                    <RenombradoViewer
                        renombrar={api.renombrar}
                        key={infraccionesResponse.data!.value[currentInfraccionIndex]!.Id}
                        //onSave={loadItems}
                        //infraccion={infraccionesResponse.data!.value[currentInfraccionIndex]!} 
                        />*/}
                </InfraccionesBrowser>
            </div>


        </RenombradorLayout>
    );
};